import React from 'react'

import s from './FilterButton.scss'


const FilterButton = ({ children, onClick }) => (
  <div className={s.filterButton} onClick={onClick}>
    {children}
  </div>
)

export default FilterButton
